export enum ApiExceptionCodes {
  user_limit_exceeded = 'user_limit_exceeded',
  invalid_expiration_date = 'invalid_expiration_date',
  invalid_feature_access = 'invalid_feature_access',
  invalid_password = 'invalid_password',
  email_already_in_use = 'email_already_in_use',
  blank_attribute = 'blank_attribute',
  not_found = 'not_found',
  bad_request = 'bad_request',
  unauthorized = 'unauthorized',
  length_exceeded = 'length_exceeded',
  uniqueness_constraint_violation = 'uniqueness_constraint_violation',
}

export interface ApiError {
  status: number;
  code: ApiExceptionCodes;
  title?: string;
}
